/**
 * Loading/Redirecting Screen Component
 * Shown when user is already logged in and being redirected
 */
export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-teal-50/30 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Omdirigerer...</p>
      </div>
    </div>
  );
}
